import type { ModalMapType } from "../../../../../common-deprecated/types/CommonTypes";
import { aemToyotaCommonModalMap } from "../../../../../common-deprecated/components/modals/aem/modals";
import type { CompareV2ModalIdsType } from "../../../../../shared-logic/features/compare/utils/modalConstants";
import {
    MODAL_DELETE_CAR,
    MODAL_REPLACE_CAR,
    MODAL_SELECT_ENGINE,
} from "../../../../../shared-logic/features/compare/utils/modalConstants";
import ToyotaDeleteCarModal from "./DeleteCarModal";
import ToyotaReplaceCarModal from "./ReplaceCarModal";
import ToyotaSelectEngineModal from "./SelectEngineModal";

export const aemToyotaCompareModalMap: ModalMapType<CompareV2ModalIdsType> = {
    ...aemToyotaCommonModalMap,
    [MODAL_DELETE_CAR]: ToyotaDeleteCarModal,
    [MODAL_REPLACE_CAR]: ToyotaReplaceCarModal,
    [MODAL_SELECT_ENGINE]: ToyotaSelectEngineModal,
};
